import type { ClientSiteConfigs } from '@magicschool/business-logic/site-configs';
import { createStoreSlice } from '@/features/store/zustand';

export type SiteConfigStore = {
  siteConfigs: ClientSiteConfigs;
  setMaintenance: (maintenance: ClientSiteConfigs['maintenance']) => void;
};

type InitialData = {
  siteConfigs: ClientSiteConfigs;
};

export const createSiteConfigStoreSlice = ({ siteConfigs }: InitialData) => {
  return createStoreSlice('SiteConfigStoreData', { siteConfigs }, ({ get, set }) => ({
    setMaintenance: (maintenance) => {
      set({ siteConfigs: { ...get().siteConfigs, maintenance } });
    },
  }));
};
